import { render, staticRenderFns } from "./SorrowIcon.vue?vue&type=template&id=e879c3a4&"
import script from "./SorrowIcon.vue?vue&type=script&lang=js&"
export * from "./SorrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports